import axios from 'axios';

import { API } from '@/config/constants';


export const getNotifications = async (config) => {
  const response = await axios.get(`${API}/notifications`, ...(config ? [config] : []));
  return response.data;
};

export const markNotificationRead = async (notificationId, config) => {
  const response = await axios.post(`${API}/notifications/${notificationId}/read`, {}, ...(config ? [config] : []));
  return response.data;
};

export const markAllNotificationsRead = async (config) => {
  const response = await axios.post(`${API}/notifications/read-all`, {}, ...(config ? [config] : []));
  return response.data;
};

export const clearNotifications = async (config) => {
  const response = await axios.delete(`${API}/notifications`, ...(config ? [config] : []));
  return response.data;
};

export const registerPushSubscription = async (subscription, config) => {
  const response = await axios.post(`${API}/push/subscribe`, { subscription }, ...(config ? [config] : []));
  return response.data;
};

export const getPushSubscriptionStatus = async (subscription, config) => {
  const response = await axios.post(`${API}/push/status`, { subscription }, ...(config ? [config] : []));
  return response.data;
};
